//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { TemplateHelper, ConfigHelper, LocalizationHelper } from "../../helpers"
import { Activity, Enums } from "../../models/common"

import { USER_SESSION_SERVICE_NAME, UserSessionService } from "../user-session"
import { SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListService } from "../system"

//#region Public Types

export const GROUPING_LOCATION_CONTEXT_MENU_SERVICE_NAME = 'groupingLocationContextMenuService'
export const GROUPING_LOCATION_CONTEXT_MENU_SERVICE_PROVIDER_NAME = 'groupingLocationContextMenuServiceProvider'

export type GroupingLocationGridContextMenuOptions = {
    idReferenceTypes?: number[]
    onEdit?: () => void
    onAssignedLocationsEdit?: () => void
}

//#endregion

export class GroupingLocationContextMenuService {

    // #region Ctor

    public constructor(
        private readonly systemContextListService: SystemContextListService,
        private readonly userSessionService: UserSessionService
    ) { }

    // #endregion


    // #region Public Methods

    public getContextMenuItems(options: GroupingLocationGridContextMenuOptions): any[] {
        const items: { beginGroup?: boolean, template: string, onItemClick: (args: any) => void }[] = []

        if (options == null) {
            return items
        }

        if (options.onEdit != null && this.userSessionService.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSessionService),

                onItemClick: (e: any) => {
                    options.onEdit()
                }
            })
        }

        if (
            _.size(options.idReferenceTypes) === 1
            && options.onAssignedLocationsEdit != null
            && this.userSessionService.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_EDIT)
        ) {
            items.push({
                template: TemplateHelper.getContextMenuItem(
                    LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignLocations),
                    ConfigHelper.Icon.SWAP_HORIZ,
                    this.userSessionService
                ),
                onItemClick: (e: any) => {
                    options.onAssignedLocationsEdit()
                }
            })
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.DEVICE_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DeviceModule)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowDevices), ConfigHelper.Icon.DEVICES, this.userSessionService),

                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.SerialNbr, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                }
            })
        }

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_LIST)
            && !this.userSessionService.getLoggedOperator().hasPermission(Activity.METER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.MeterModule)) {
            items.push({
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ShowMeters), ConfigHelper.Icon.METERS, this.userSessionService),

                onItemClick: () => {
                    this.systemContextListService.getContextList(Enums.ReferenceType.IdMeter, options.idReferenceTypes, Enums.ReferenceType.IdLocation)
                }
            })
        }


        return items
    }

    // #endregion
}

export class GroupingLocationContextMenuServiceProvider
    implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [SYSTEM_CONTEXT_LIST_SERVICE_NAME, USER_SESSION_SERVICE_NAME, function (systemContextListService: SystemContextListService, userSessionService: UserSessionService) {
        return new GroupingLocationContextMenuService(systemContextListService, userSessionService)
    }]

    //#endregion
} 
